import { FC } from 'react';
import TileWithIcIcon, {
    TIconTile,
} from '@/features/contentful/components/ContentBlockWithTile/TileWithIcIcon';
import classNames from 'classnames';
import { applyPaddings } from '@/utils/applyPaddings';

interface Props {
    items: TIconTile[];
    title?: string;
    subtitle?: string;
    paddingTop?: string;
    paddingBottom?: string;
    bgColor?: 'blue' | 'red' | 'dark blue';
}

const ContentBlockWithTile: FC<Props> = ({
    items,
    title,
    paddingTop,
    paddingBottom,
    bgColor,
    subtitle,
}) => {
    return (
        <section
            style={applyPaddings({ paddingTop, paddingBottom })}
            className={classNames('tw-w-full  tw-pt-[40px] tw-pb-[25px]', {
                'tw-bg-bgSkyLight': bgColor === 'blue',
                'tw-bg-bgNavy': bgColor === 'dark blue',
            })}
        >
            {subtitle && (
                <h2 className="tw-pb-1 tw-text-center tw-text-pink1 tw-uppercase tw-text-sm tw-font-gotham-medium">
                    {subtitle}
                </h2>
            )}
            {title && (
                <h3
                    className={classNames(
                        'tw-text-center tw-font-gotham-bold tw-text-[26px] lg:tw-text-[32px] tw-pb-[30px]',
                        {
                            'tw-text-white': bgColor === 'dark blue',
                            'tw-text-textBlue': bgColor !== 'dark blue',
                        },
                    )}
                >
                    {title}
                </h3>
            )}
            <div className="container tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-4 tw-gap-5 ">
                {items.map((item) => (
                    <TileWithIcIcon
                        key={item.title}
                        id={item.id ?? ''}
                        title={item.title}
                        image={item.image}
                        summary1={item.summary1}
                        summary2={item.summary2}
                        summaryDoc={item.summaryDoc}
                    />
                ))}
            </div>
        </section>
    );
};

export default ContentBlockWithTile;
